import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { HistoryIcon, SearchIcon } from '@fiverr-private/visuals';
import { Container } from '@fiverr-private/layout_components';
import SearchHighLighter from '../../../components/SearchHighLighter';
import { mapStateToProps, mapDispatchToProps } from '../connectSuggestionItem';
import { aiPillRowClass, aiPillRowSelectedClass } from '../styles.ve.css';

const AiSuggestionRow = ({ id, value, isSelected, isHistory, onClick }) => {
    const Icon = isHistory ? HistoryIcon : SearchIcon;

    const handleClick = (e) => {
        e.preventDefault();
        onClick(value);
    };

    return (
        <li>
            <Container
                as="button"
                type="button"
                className={classNames(aiPillRowClass, { selected: isSelected, [aiPillRowSelectedClass]: isSelected })}
                display="flex"
                alignItems="center"
                paddingX={{ default: '0', md: '4' }}
                paddingY={{ default: '1', md: '2' }}
                borderRadius="2xl"
                onClick={handleClick}
                data-id={id}
            >
                <Container
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    width={{ default: '28px', md: '36px' }}
                    height={{ default: '28px', md: '36px' }}
                    borderRadius="lg"
                    backgroundColor="grey_200"
                    flexShrink="0"
                >
                    <Icon color="grey_900" size="sm" />
                </Container>
                <Container marginLeft="3" color="grey_1200" fontSize={{ default: 'b_sm', md: 'b_md' }}>
                    <SearchHighLighter text={value} />
                </Container>
            </Container>
        </li>
    );
};

AiSuggestionRow.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    isSelected: PropTypes.bool,
    isHistory: PropTypes.bool,
    onClick: PropTypes.func,
};

AiSuggestionRow.defaultProps = {
    value: '',
    isSelected: false,
    isHistory: false,
    onClick: () => true,
};

export { AiSuggestionRow };

export default connect(mapStateToProps, mapDispatchToProps)(AiSuggestionRow);
